import * as React from "react";
import { AlertOctagon, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

interface SafetyAlertProps {
  /** "error" must be acted on (e.g. allergy match); "warning" needs a second look */
  level?: "error" | "warning";
  title: string;
  /** The reason in plain words */
  children?: React.ReactNode;
  className?: string;
}

/** Inline clinical safety alert — red for a hard stop, amber for a caution. */
export function SafetyAlert({ level = "error", title, children, className }: SafetyAlertProps) {
  const Icon = level === "error" ? AlertOctagon : AlertTriangle;
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2 rounded-md border px-3 py-2",
        level === "error" ? "border-destructive/30 bg-destructive/10" : "border-warning/30 bg-highlight",
        className
      )}
    >
      <Icon className={cn("w-4 h-4 mt-0.5 flex-shrink-0", level === "error" ? "text-destructive" : "text-highlight-foreground")} aria-hidden />
      <div className="min-w-0 text-sm">
        <p className={cn("font-semibold", level === "error" ? "text-destructive" : "text-highlight-foreground")}>{title}</p>
        {children && <div className="text-xs text-foreground/80">{children}</div>}
      </div>
    </div>
  );
}
